/**
 * FERP Portal - Checkpoint List Page (DRR-074: Tabulator DRY Template)
 *
 * MONITOR Phase: Workflow checkpoints and savepoints.
 * Delegates to TabulatorPrimitiveManager for consistent CRUD across all 25 primitives.
 */

import { TabulatorPrimitiveManager } from '@/components/primitives/TabulatorPrimitiveManager';

export function CheckpointListPage() {
  return <TabulatorPrimitiveManager primitiveType="checkpoint" />;
}

export default CheckpointListPage;
